import { useState, useEffect, useCallback } from 'react'
import { fetchDraftOrder, parseMetafield, type DraftOrder, type PaymentMetafield } from '../lib/graphql'

type UseDraftOrderResult = {
    draftOrder: DraftOrder | null
    payment: PaymentMetafield | null
    loading: boolean
    error: string | null
    refresh: () => void
}

export function useDraftOrder(draftOrderId: string): UseDraftOrderResult {
    const [draftOrder, setDraftOrder] = useState<DraftOrder | null>(null)
    const [payment, setPayment] = useState<PaymentMetafield | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    const refresh = useCallback(async () => {
        try {
            setError(null)
            const data = await fetchDraftOrder(draftOrderId)
            setDraftOrder(data)
            setPayment(parseMetafield(data.metafield))
        } catch (err: any) {
            setError(err.message || 'Failed to load draft order')
        } finally {
            setLoading(false)
        }
    }, [draftOrderId])

    useEffect(() => {
        refresh()
    }, [refresh])

    return { draftOrder, payment, loading, error, refresh }
}
